import React from "react";
import DatePicker from "react-datepicker";

export const ChangeEndDate = ({
  msg,
  okButtonShow,
  okButtonText,
  okAction,
  cancelButtonShow,
  cancelButtonText,
  closeAction,
  handleDate,
  minStartDate,
  startDate,
}) => {
    let styles = {
        marginBottom: '20px'
      }
  //Model shows the limit exceed the limit
  return (
    <div className="modal-overlay">
    <div
      className="modal-wrapper thankyou-popup"
      aria-modal
      aria-hidden
      tabIndex={-1}
      role="dialog"
    >
      <div className="modal approval">
        <div className="modal-head-cross rate-modal">
          <button
            type="button"
            className="modal-close-button"
            onClick={closeAction}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="popup_txt">
            <div style={styles}>{msg}</div>
            <DatePicker
              placeholderText="Select Start Date"
              dateFormat="dd/MM/yyyy"
              minDate={minStartDate}
              selected={startDate? startDate: Date.now()}
              onSelect={handleDate}
            />
          </div>
          <div className="popup_footer" style={{marginTop:'6%'}}>
            {cancelButtonShow && (
              <button                     style={{color:'white'}}
              onClick={closeAction}>{cancelButtonText}</button>
            )}
            {okButtonShow && <button onClick={okAction} style={{float:"right", color:"white"}}>{okButtonText}</button>}
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/ChangeEndDate.jsx